module.exports = { "default": require("core-js/library/fn/object/assign"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// /~/react-bootstrap-validation/~/babel-runtime/core-js/object/assign.js
// module id = 386
// module chunks = 0